import axios from "axios";

// 创建 Axios 实例（baseURL 可通过环境变量 NEXT_PUBLIC_API_BASE_URL 配置）
const myAxios = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_BASE_URL ?? "https://yoj-backend.wisdog.asia/api",
    // baseURL: process.env.NEXT_PUBLIC_API_BASE_URL ?? "http://localhost:8081/api",
    // timeout: 10000,
    withCredentials: true,
});

// 创建请求拦截器
myAxios.interceptors.request.use(
    function (config) {
        // 请求执行前执行
        return config;
    },
    function (error) {
        // 处理请求错误
        return Promise.reject(error);
    },
);

// 创建响应拦截器
myAxios.interceptors.response.use(
    // 2xx 响应触发
    function (response) {
        // 处理响应数据
        const { data } = response;
        // 未登录时不再强制跳转登录页，只把错误抛给调用方处理
        if (data.code !== 0) {
            throw new Error(
                data.message ?? (data.code === 40100 ? "请先登录" : "服务器错误"),
            );
        }
        return data;
    },
    // 非 2xx 响应触发
    function (error) {
        // 处理响应错误
        return Promise.reject(error);
    },
);

export default myAxios;